// extracted by mini-css-extract-plugin
export default {"button":"vodHb5PocEV1a2juIuc_"};